export default "__VITE_ASSET__BihGH6Bi__"